import React, { FunctionComponent } from 'react';
import { MobileCartSummaryButtonVariant } from '../../constants/statsig';
import { getSimplifyCartSummaryButtonExperiment } from '../../utils/statsig';
import ConnectedCartSummary, {
    ConnectedCartSummaryProps,
} from '../CartSummary';
import LegacyCartSummary, {
    LegacyCartSummaryProps,
} from '../LegacyCartSummary';

export type CartSummarySwitcherProps = LegacyCartSummaryProps &
    ConnectedCartSummaryProps;

export const CartSummarySwitcher: FunctionComponent<
    CartSummarySwitcherProps
> = ({ isPaneOpen, onClick, ticketQuantity, totalCost }) =>
    getSimplifyCartSummaryButtonExperiment() ===
    MobileCartSummaryButtonVariant.unifiedIntoPrice ? (
        <ConnectedCartSummary isPaneOpen={isPaneOpen} onClick={onClick} />
    ) : (
        <LegacyCartSummary
            isPaneOpen={isPaneOpen}
            onClick={onClick}
            ticketQuantity={ticketQuantity}
            totalCost={totalCost}
        />
    );
